// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 462) return "static/chunks/462-229bdf9cfbdb5e7c.js";
	if (chunkId === 545) return "static/chunks/545-c2f4b5d0e13f9333.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"290":"15ff6dc4251b9fa2","518":"b15acb82a40f1d45"}[chunkId] + ".js";
};